import { createContext } from 'react';

export interface ContextValue {
	analysisId: string | null;
}

export const AnalysisContext = createContext<ContextValue>({
	analysisId: null
});
